<div
  class="modal-header d-flex justify-content-center p-0 mb-2 position-relative"
  style="background-image: linear-gradient(to bottom, var(--primaryContainer), var(--surface));"
>
   <button
    type="button"
    class="btn-close"
    aria-label="Close"
    (click)="closeNotify()"
    style="position: absolute; top: 8px; right: 8px;"
  ></button>

  <div
    class="w-100 d-flex align-items-center justify-content-center"
    style="
      height: 100px;
      background-repeat: repeat;
      background-image: url('assets/images/trial-mask-bg.png');
    "
  ></div>
</div>

<div class="modal-body d-flex flex-column align-items-center pb-1">
  <span class="fw-bold font-size-18 mb-6">
   Upgrade to {{ requiredPlanTitle }}! 🚧
  </span>

  <span class="fw-bold font-size-16 mt-4 mb-2 text-center">
    This feature isn’t available on your plan.
  </span>

<span class="fw-bold font-size-14 mb-4 text-center">
  You’ll need to upgrade to the {{ requiredPlanTitle }} plan<span *ngIf="showOrHigher"> or higher</span>.
</span>

  <span class="fw-bold font-size-16 mb-3">
    Unlock more features with {{ requiredPlanTitle }}!💡
  </span>

  <span class="fw-bold font-size-14 mb-3 text-center">
    Upgrade now and deliver a better experience for your users.
  </span>

  <span class="fw-bold font-size-14 mb-4">
    No risk, cancel anytime.
  </span>

  <div class="d-flex align-items-center mb-4">
    <md-filled-tonal-button
      type="button"
      class="me-2"
      (click)="viewPlans()"
    >
      View Plan Options
    </md-filled-tonal-button>

    <md-filled-button
      type="button"
      (click)="unlockProfessionalApp()"
    >
      Upgrade to {{ requiredPlanTitle }} Now
    </md-filled-button>
  </div>
</div>
